"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCREEN_SHARE_REQUEST = exports.MUTE_REQUEST = exports.CAMERA_REQUEST = void 0;
var MUTE_REQUEST = exports.MUTE_REQUEST = 'canUnMute';
var CAMERA_REQUEST = exports.CAMERA_REQUEST = 'canToggleCamera';
var SCREEN_SHARE_REQUEST = exports.SCREEN_SHARE_REQUEST = 'canScreenShare';